import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignHorizontalCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAlignHorizontalCenter"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM11 17H13V7H11L11 17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlignHorizontalCenter;
